<div class="gallery-content-group"
     [class.micro]="sizeCard === eSizeCard.micro"
     [class.mid]="sizeCard === eSizeCard.mid"
     [class.normal]="sizeCard === eSizeCard.normal">
  <div *ngFor="let row of rowsContent; let i = index; trackBy: trackByFn"
       class="row"
       [class.odd]="i % 2">
    <div *ngFor="let itemContent of row; let i = index; trackBy: trackByFn"
         class="content-item">
      <app-gallery-content-card [content]="itemContent"
                                [sizeCard]="sizeCard"
                                (openCard)="onOpenCard($event)">
      </app-gallery-content-card>
    </div>
  </div>
</div>
